import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-poc-dev-sujeet',
  templateUrl: './poc-dev-sujeet.component.html',
  styleUrls: ['./poc-dev-sujeet.component.css']
})
export class PocDevSujeetComponent implements OnInit {
  @Output() openPopupEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  openPopup() {
    this.openPopupEvent.emit(event);
    console.log('openpopup() called in poc page.');
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/poc-dev-sujeet/poc-dev-sujeet.component.ts